import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoiceLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/vendor-payment', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
